// extracted by mini-css-extract-plugin
module.exports = {"text-figures":"text-figures--3d4mU","vertical-chart":"vertical-chart--1N2dr","chart-value":"chart-value--1pd6b","status-chart":"status-chart--3JLQg"};